module.exports = __webpack_public_path__ + "static/img/9.92f5dec.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/9.png
// module id = TIo9
// module chunks = 1